import { gql, useMutation } from "@apollo/client";

const UPDATE_HOMEOWNER_ACCOUNT_MUTATION = gql`
  mutation UpdateHomeownerAccount(
    $_id: ID!
    $firstName: String
    $lastName: String
    $email: String
    $phoneNumber: String
    $address: String
    $city: String
    $state: String
    $zipCode: String
    $dmaCode: String
    $subscription: String
    $image: ID
  ) {
    updateHomeownerAccount(
      _id: $_id
      firstName: $firstName
      lastName: $lastName
      email: $email
      phoneNumber: $phoneNumber
      address: $address
      city: $city
      state: $state
      zipCode: $zipCode
      dmaCode: $dmaCode
      subscription: $subscription
      image: $image
    ) {
      id
      firstName
      lastName
      email
      phoneNumber
      address
      city
      state
      zipCode
      image
      accountType
      aliasId
      emailVerified
      onboardingStatus
      paymentStatus
      subscription {
        ... on DesignerSubscriptionWrapper {
          designerValue: value
        }
        ... on HomeOwnerSubscriptionWrapper {
          homeownerValue: value
        }
      }
    }
  }
`;

export const useUpdateHomeownerAccountMutation = () => {
  const [updateHomeownerAccount, { loading, error, data }] = useMutation(
    UPDATE_HOMEOWNER_ACCOUNT_MUTATION
  );

  return { updateHomeownerAccount, loading, error, data };
}; 
